<template>
    <div class="w-100">
        <v-card-title class="title font-weight-regular justify-space-between">
            &#xca;tes-vous sûr(e) de vouloir passer cette transaction à l'encaissement ?
            <v-avatar
                color="primary-lighten-2"
                class="subheading white--text"
                size="24"
                v-if="step"
            >
                {{ step }}
            </v-avatar>
        </v-card-title>
        <v-card-text>
            <v-row>
                <v-col cols="12">
                    <AccountableAccountVue
                        v-show="true"
                        :showLabel="true"
                        :showValidation="false"
                        :companyId="companyId"
                        :inAccountableAccountType="'SalesWithOtherIncomes'"
                        :inAccountableAccount="accountableAccount"
                        @select-accountableAccount="selectAccountableAccount"
                        v-if="isAccountingUser"
                    />
                </v-col>
            </v-row>
        </v-card-text>
        <v-card-actions v-if="!actions">
            <v-btn rounded @click="cancel()" style="margin: center" size="small">
                {{ step ? "Précédent" : "Annuler" }}
            </v-btn>
            <v-spacer />
            <v-btn
                rounded
                @click="executeAutoSalesReconciliation"
                :loading="loading"
                :disabled="!accountableAccount"
                size="small"
            >
                Oui, je suis sûr(e)
            </v-btn>
        </v-card-actions>
    </div>
</template>

<script lang="ts">
import { User } from "../../store/store";

import { AccountableAccount } from "../../../../types";
import { updateBankTransactionAccountableAccount } from "../../services/bankTransactionServices";

import AccountableAccountVue from "../AccountableAccount.vue";
import { Component, Vue, toNative } from "vue-facing-decorator";
import { Prop } from "vue-facing-decorator";

@Component({
    components: {
        AccountableAccountVue,
    },
    emits: ["added", "cancel"],
})
export class AutoSales extends Vue {
    @Prop({ default: "" }) companyId: string;
    @Prop({ default: null }) btItem: any;

    @Prop({ default: null }) step: any;
    @Prop({ default: false }) externalValidation: any;

    @Prop({ default: null }) actions: any;

    loading: boolean = false;

    get currentUser(): User {
        return this.$store.state.user;
    }

    get isAccountingUser() {
        return this.currentUser.isAccountingUser;
    }

    beforeMount() {
        if (this.actions) {
            this.actions.action.title = "Oui, je suis sûr(e)";
            this.actions.action.disabled = () => {
                return !this.accountableAccount;
            };
            this.actions.action.function = this.executeAutoSalesReconciliation;
            this.actions.action.loading = () => {
                return this.loading;
            };
        }
    }

    executeAutoSalesReconciliation() {
        // hack : waiting comboxbox blur
        setTimeout(async () => {
            this.loading = true;
            let customer;
            // if (this.customer) {
            //     if (typeof this.customer === 'string') {
            //         customer = {
            //             id: "",
            //             name: this.customer
            //         }
            //         const name = this.customer.toLowerCase();
            //         for (const ec of this.customers) {
            //             if (ec.name.toLowerCase() === name) {
            //                 customer = ec;
            //                 break;
            //             }
            //         }
            //     } else {
            //         customer = this.customer
            //     }
            // }
            if (!this.externalValidation) {
                if (this.btItem) {
                    const firstBT = this.btItem.bt;
                    // const date = firstBT.dateDebit || firstBT.dateRealization
                    const amountSigned = -this.btItem.accountingLine.amountSigned;

                    if (firstBT && amountSigned) {
                        const data = {
                            accountableAccount: this.accountableAccount,
                        };
                        await updateBankTransactionAccountableAccount(
                            this.$apollo,
                            this.$store,
                            this.companyId,
                            [firstBT],
                            data,
                            this.btItem.accountingLine,
                        );
                        this.$emit("added");
                        this.customer = null;
                    } else {
                        debugger;
                    }
                } else {
                    debugger;
                }
            } else {
                this.$emit("create", {
                    accountableAccount: this.accountableAccount,
                    thirdPartyCompany: customer,
                });
                this.customer = null;
            }
            this.loading = false;
        }, 50);
    }

    cancel() {
        this.$emit("cancel");
    }

    accountableAccount: AccountableAccount = null;

    selectAccountableAccount(data) {
        this.accountableAccount = data.accountableAccount;
    }

    // @Apollo({
    //     query: CUSTOMER_COMPANIES,
    //     variables() {
    //         return {
    //             companyId: this.companyId
    //         };
    //     },
    //     debounce: 500,
    //     skip() {
    //         return !this.companyId;
    //     },
    //     specificResult({ data, loading, networkStatus }: any) {
    //         if (!loading) {
    //             if (data) {
    //                 // console.log(data)
    //                 if (data.customerCompanies) {
    //                     this.customers = data.customerCompanies
    //                 } else {
    //                     this.customers = [];
    //                 }
    //             }
    //         }
    //     }
    // })
    customers: Array<any> = [];
    customer = null;
}

export default toNative(AutoSales);
</script>
